import { CoinIcon } from '@ping/uikit/CoinIcon';
import React, { useState } from 'react';

import style from './style.module.scss';

interface IProps {
  className?: string;
  coinName: string;
  /** Optional icon URL from asset - when provided, used as primary source */
  iconUrl?: string | null;
  title?: string;
  coinFullName?: string;
}

export const CoinItem = React.forwardRef<HTMLDivElement, IProps>((props, ref) => {
  const { className = '', coinName, iconUrl, title, coinFullName = '' } = props;
  const [showName, setShowName] = useState(true);

  return (
    <div ref={ref} className={`${style['coin-item']} ${className}`}>
      <CoinIcon
        className={style['coin-item__icon']}
        iconUrl={iconUrl}
        onError={() => setShowName(false)}
        name={coinName}
      />
      {showName && (
        <span className={style['coin-item__title']}>
          {title ?? coinName}
          {coinFullName ? ` - ${coinFullName}` : ''}
        </span>
      )}
    </div>
  );
});
